export default "__VITE_ASSET__BAlfbWLK__"